import { timeSlicer } from "../../Alerts/timeSlicer";
import { formatSentinalDate } from "./getSentinelClipsWithQuerry";
import { clipResultParam } from "./clipResultParam";

export const generateDownloadStringSentinel = (userFiltersSentinel: any) => {
  const convertTimeToUTCFormat = (time: string): string => {
    const [hours, minutes] = time.split(":");
    return encodeURIComponent(`${hours}:${minutes}`);
  };

  const sameDay =
    userFiltersSentinel.start_date !== null &&
    userFiltersSentinel.end_date !== null &&
    userFiltersSentinel.start_date.toString() ===
      userFiltersSentinel.end_date.toString();

  let searchParamsString = `?username=${userFiltersSentinel.user}`;

  if (userFiltersSentinel.site_ids[0]) {
    searchParamsString += `&site_ids=${userFiltersSentinel.site_ids[0]}`;
  }

  if (userFiltersSentinel.camera_ids[0]) {
    searchParamsString += `&camera_ids=${userFiltersSentinel.camera_ids[0]}`;
  }

  if (userFiltersSentinel.start_date) {
    searchParamsString += `&start_date=${formatSentinalDate(
      userFiltersSentinel.start_date
    )}`;
  }

  if (userFiltersSentinel.end_date) {
    searchParamsString += `&end_date=${formatSentinalDate(
      userFiltersSentinel.end_date
    )}`;
  }

  if (sameDay && userFiltersSentinel.start_time !== null) {
    searchParamsString += `&start_time=${convertTimeToUTCFormat(
      timeSlicer(userFiltersSentinel.start_time)
    )}`;
  }

  if (sameDay && userFiltersSentinel.end_time !== null) {
    searchParamsString += `&end_time=${convertTimeToUTCFormat(
      timeSlicer(userFiltersSentinel.end_time)
    )}`;
  }

  searchParamsString += clipResultParam(userFiltersSentinel.clip_result);

  // Scope the report to the selected group rather than the whole parent
  // account (username), which can span multiple groups.
  if (userFiltersSentinel.group_id) {
    searchParamsString += `&group_id=${userFiltersSentinel.group_id}`;
  }

  return searchParamsString;
};
